export const GET_BIDS_REQUEST = "GET_BIDS_REQUEST"
export const GET_BIDS_SUCCESS = "GET_BIDS_SUCCESS"
export const GET_BIDS_FAILED = "GET_BIDS_FAILED"

export const EXPORT_BIDS_REQUEST = "EXPORT_BIDS_REQUEST"
export const EXPORT_BIDS_SUCCESS = "EXPORT_BIDS_SUCCESS"
export const EXPORT_BIDS_FAILED = "EXPORT_BIDS_FAILED"

export const GetBidsAction = (hour: any,  userId:String,appBundle:String,ipAddress:String,ipv6:String,url:String)=>{
    return{
        type:GET_BIDS_REQUEST,payload: { hour, userId,appBundle,  ipAddress,ipv6,url}
    }
}

// export const exportCBIDDataAction = (hour: any,  userId:String,appBundle:String,ipAddress:String,ipv6:String,url:String) => {
//     return { 
//         type: EXPORT_BIDS_REQUEST, payload: { hour, userId,appBundle,  ipAddress,ipv6,url }
//     }
// }